<template>
  <div class="d-toolbar">
    <div>
      <div class="d-toolbar__box" v-if="$store.getters.isMobile">
        <div
          class="berger-menu"
          @click="$store.dispatch('theme/toggleSideNav')"
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div
        class="d-toolbar__box d-toolbar__box--page-title"
        v-html="$store.state.page.name"
      ></div>
    </div>
    <div style="margin: 0 20px">
      <!---->
      <div class="d-toolbar__box">
        <nuxt-link to="/reservation" class="mx-4 btn btn px-4 py-2 text-white font-bold bg-primary rounded-xl">رزرو جدید</nuxt-link>


        <div class="dropdown-nav">
          <div class="dropdown-nav__btn">
            <img src="@/assets/media/user-icon.png" class="avatar" />
            <span class="dropdown-nav__btn__content">
              <div class="dropdown-nav__btn__content__title">خوش آمدید</div>
              <div class="dropdown-nav__btn__content__subtitle">
                {{
                  $store.state.auth.user.first_name +
                  " " +
                  $store.state.auth.user.last_name
                }}
                <svg viewBox="0 0 11 7" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.68571 0.287462L5.50513 4.10688L9.32455 0.287462C9.41569 0.196325 9.52388 0.124032 9.64296 0.0747094C9.76204 0.0253867 9.88966 9.60281e-10 10.0185 0C10.1474 -9.60276e-10 10.2751 0.0253867 10.3941 0.0747094C10.5132 0.124032 10.6214 0.196325 10.7125 0.287462C10.8037 0.378598 10.876 0.486793 10.9253 0.605868C10.9746 0.724944 11 0.852568 11 0.981455C11 1.11034 10.9746 1.23797 10.9253 1.35704C10.876 1.47612 10.8037 1.58431 10.7125 1.67545L6.1942 6.19379C6.10313 6.28504 5.99496 6.35744 5.87587 6.40684C5.75679 6.45624 5.62913 6.48166 5.50021 6.48166C5.37129 6.48166 5.24363 6.45624 5.12454 6.40684C5.00546 6.35744 4.89729 6.28504 4.80622 6.19379L0.287878 1.67545C0.196622 1.58438 0.124222 1.47621 0.0748244 1.35712C0.0254265 1.23804 0 1.11038 0 0.981455C0 0.852531 0.0254265 0.724873 0.0748244 0.605789C0.124222 0.486704 0.196622 0.378531 0.287878 0.287462C0.671789 -0.0866056 1.3018 -0.0964495 1.68571 0.287462Z"
                  />
                </svg>
              </div>
            </span>
          </div>
          <div class="dropdown-nav__box">
            <ul>
              <li style="padding-bottom: 20px">
                <div>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 0C3.6632 0 0 3.6632 0 8C0 10.5512 1.2736 12.8624 3.2 14.3392V14.4H3.2816C4.616 15.396 6.2504 16 8 16C9.7496 16 11.384 15.396 12.7184 14.4H12.8V14.3392C14.7264 12.8624 16 10.552 16 8C16 3.6632 12.3368 0 8 0ZM4.8592 13.5416C4.97709 13.0083 5.27323 12.5311 5.69877 12.1888C6.12432 11.8464 6.65384 11.6594 7.2 11.6584H8.8C9.34612 11.6595 9.87557 11.8466 10.3011 12.189C10.7266 12.5313 11.0228 13.0084 11.1408 13.5416C10.2064 14.0832 9.1328 14.4 8 14.4C6.8672 14.4 5.7936 14.0832 4.8592 13.5416ZM12.488 12.5128C12.1828 11.7863 11.6702 11.1659 11.0142 10.7294C10.3582 10.2928 9.58799 10.0594 8.8 10.0584H7.2C6.41201 10.0594 5.64181 10.2928 4.98581 10.7294C4.32982 11.1659 3.81716 11.7863 3.512 12.5128C2.3384 11.3456 1.6 9.7408 1.6 8C1.6 4.5304 4.5304 1.6 8 1.6C11.4696 1.6 14.4 4.5304 14.4 8C14.4 9.7408 13.6616 11.3456 12.488 12.5128Z"
                    />
                    <path
                      d="M8.00078 3.2002C6.17678 3.2002 4.80078 4.5762 4.80078 6.4002C4.80078 8.2242 6.17678 9.6002 8.00078 9.6002C9.82478 9.6002 11.2008 8.2242 11.2008 6.4002C11.2008 4.5762 9.82478 3.2002 8.00078 3.2002ZM8.00078 8.0002C7.05838 8.0002 6.40078 7.3426 6.40078 6.4002C6.40078 5.4578 7.05838 4.8002 8.00078 4.8002C8.94318 4.8002 9.60078 5.4578 9.60078 6.4002C9.60078 7.3426 8.94318 8.0002 8.00078 8.0002Z"
                    />
                  </svg>
                  <span>{{$store.state.auth.user.mobile}}</span>
                </div>
              </li>
              <li class="dropdown-nav__box__footer">
                <a href="#" @click.prevent="$auth.logout()">
                  <svg
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.90476 10.6667V12.1905C9.90476 12.5946 9.74422 12.9822 9.45845 13.268C9.17268 13.5537 8.78509 13.7143 8.38095 13.7143H1.52381C1.11967 13.7143 0.732083 13.5537 0.446313 13.268C0.160544 12.9822 0 12.5946 0 12.1905V1.52381C0 1.11967 0.160544 0.732083 0.446313 0.446313C0.732083 0.160544 1.11967 0 1.52381 0H8.38095C8.78509 0 9.17268 0.160544 9.45845 0.446313C9.74422 0.732083 9.90476 1.11967 9.90476 1.52381V3.04762H8.38095V1.52381H1.52381V12.1905H8.38095V10.6667H9.90476ZM11.8095 2.66667L10.7322 3.744L13.0834 6.09524H5.33333V7.61905H13.0834L10.7322 9.97029L11.8095 11.0476L16 6.85714L11.8095 2.66667Z"
                    />
                  </svg>
                  <span>خروج از پنل مدیریت</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toolbar",
  mounted() {
    $(".dropdown-nav").hover(
      function () {
        $(this).find(".dropdown-nav__box").addClass("show");
      },
      function () {
        $(this).find(".dropdown-nav__box").removeClass("show");
      }
    );
  },
  methods: {},
};
</script>

<style scoped></style>
